import { render, staticRenderFns } from "./TruckTrackingStats.vue?vue&type=template&id=50cf4ec6&scoped=true&"
import script from "./TruckTrackingStats.vue?vue&type=script&lang=js&"
export * from "./TruckTrackingStats.vue?vue&type=script&lang=js&"
import style0 from "./TruckTrackingStats.vue?vue&type=style&index=0&id=50cf4ec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cf4ec6",
  null
  
)

export default component.exports